import moment from 'moment';

/* Форматы вывода режима «Факультеты» (п. 11 ТЗ).
   Сервер отдаёт дату как YYYY-MM-DD, ставку — строкой с точкой («1.00»),
   незаполненное значение — null. Приводит к виду для экрана клиент. */

export const isEmpty = (value) => value == null || value === '';

// Дата — ДД.ММ.ГГГГ. Нераспознанное значение выводится как есть, а не «Invalid date».
export const formatDate = (value) => {
  if (isEmpty(value)) return null;
  const date = moment(value, 'YYYY-MM-DD', true);
  return date.isValid() ? date.format('DD.MM.YYYY') : value;
};

// Ставка — два знака через запятую. Округлять нельзя: 0,50 доходит до экрана как есть.
export const formatRate = (value) => (isEmpty(value) ? null : String(value).replace('.', ','));
